import { ChangeDetectorRef, Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { BehaviorSubject } from 'rxjs';
import { GeotabEulaService } from '../../services/geotab-eula/geotab-eula.service';

@Component({
  selector: 'app-geotab-eula',
  templateUrl: './geotab-eula.component.html',
  styleUrls: ['./geotab-eula.component.scss'],
})
export class GeotabEulaComponent implements OnInit {
  @ViewChild('eulaTextContainer') scrollContainer: ElementRef;

  private consentLoading = new BehaviorSubject(true);
  public eulaConsentLoading = this.consentLoading.asObservable();
  public eulaDeclined = false;
  public userScrolled: boolean = false;

  constructor(private router: Router, private cdr: ChangeDetectorRef, private geotabEulaService: GeotabEulaService) {}

  ngOnInit(): void {
    this.consentLoading.subscribe((value) => {
      this.cdr.detectChanges();
      if (!value) {
        this.scrollContainer.nativeElement.addEventListener('scroll', this.onScroll.bind(this));
      }
    });

    this.geotabEulaService.isEULAAccepted().subscribe((value) => {
      if (value) {
        this.router.navigateByUrl('geotab-login');
      }
      this.consentLoading.next(false);
    });
  }

  private onScroll() {
    if (
      this.scrollContainer.nativeElement.scrollTop >
      this.scrollContainer.nativeElement.scrollHeight - this.scrollContainer.nativeElement.offsetHeight
    )
      this.userScrolled = true;
  }

  public declineEula() {
    this.eulaDeclined = true;
    this.geotabEulaService.declineEula();
  }

  public acceptEula() {
    this.geotabEulaService.acceptEula();
  }
}
